import { ReactNode } from 'react';

import { styled, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

import ChevronLeftIcon from '~/assets/icons/ChevronLeftIcon';
import QuestionMarkIcon from '~/assets/icons/QuestionMarkIcon';
import TestCard, { QuizColorsMode } from '~/blocks/TestCard/TestCard';
import CustomButton from '~/components/UI/CustomButton/CustomButton';
import IconButton from '~/components/UI/IconButton/IconButton';
import UnstyledButton from '~/components/UI/UnstyledButton';
import { SMALL_MARGIN_PX, SUBMIDDLE_MARGIN_PX, TINY_MARGIN_PX } from '~/theme';

export const Buttons = styled('div')<{ children: ReactNode }>`
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  margin-top: auto;

  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-direction: row;
    width: unset;
  }
`;
export const NavigationButton = styled(IconButton)`
  &:not(:only-child) {
    margin-top: ${SUBMIDDLE_MARGIN_PX};

    ${({ theme }) => theme.breakpoints.up('md')} {
      margin-right: auto;
      margin-top: 0;
    }
  }
`;
export const AnswerButton = styled(CustomButton)`
  width: 100%;
  margin-left: auto;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: unset;
  }
`;
export const StyledQuestionMarkIcon = styled(QuestionMarkIcon)`
  margin-top: 1px;
  width: 24px;
  height: 24px;
`;
export const SubmitButton = styled(CustomButton, {
  shouldForwardProp: (prop) => prop !== 'colorsMode',
})<{ colorsMode?: QuizColorsMode }>`
  &.btnContainedPrimary:hover {
    color: ${({ theme, colorsMode }) =>
      colorsMode === QuizColorsMode.PostVideo && theme.palette.common.text.white};
  }
`;
export const BackButton = styled(UnstyledButton)`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 3px solid ${({ theme }) => theme.palette.common.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  margin-bottom: ${SUBMIDDLE_MARGIN_PX};
  transition: 0.3s ease all;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.palette.common.primary};

    & > svg {
      color: ${({ theme }) => theme.palette.common.blueDark};
    }
  }

  ${({ theme }) => theme.breakpoints.up('lg')} {
    position: absolute;
    left: 36px;
  }
`;
export const ExplanationText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'colorsMode',
})<{ colorsMode?: QuizColorsMode }>`
  margin-bottom: ${SUBMIDDLE_MARGIN_PX};
  color: ${({ theme, colorsMode }) =>
    colorsMode === QuizColorsMode.PostVideo
      ? theme.palette.common.text.white
      : theme.palette.common.white};
`;
export const StyledChevronLeftIcon = styled(ChevronLeftIcon)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.palette.common.text.white};
`;
export const StyledSmallTitle = styled(TestCard.SmallTitle, {
  shouldForwardProp: (prop) => prop !== 'colorsMode',
})<{ colorsMode?: QuizColorsMode }>`
  color: ${({ theme, colorsMode }) =>
    colorsMode === QuizColorsMode.PostVideo
      ? theme.palette.common.text.white
      : theme.palette.common.white};

  & > * {
    width: 100%;
  }
`;
export const TitleWrapper = styled('div')`
  padding-bottom: ${TINY_MARGIN_PX};
  border-bottom: 1px solid ${({ theme }) => alpha(theme.palette.common.white, 0.33)};
  margin-bottom: ${SMALL_MARGIN_PX};
`;
